export const PASSWORD_RECOVERY_REQUEST = "PASSWORD_RECOVERY_REQUEST";
export const PASSWORD_RECOVERY_SUCCESS = "PASSWORD_RECOVERY_SUCCESS";
export const PASSWORD_RECOVERY_ERROR = "PASSWORD_RECOVERY_ERROR";

export const passwordRecoveryRequest = (payload) => ({
  type: PASSWORD_RECOVERY_REQUEST,
  ...payload,
});

export const passwordRecoverySuccess = () => ({
  type: PASSWORD_RECOVERY_SUCCESS,
});

export const passwordRecoveryError = () => ({
  type: PASSWORD_RECOVERY_ERROR,
});



// WEBPACK FOOTER //
// ./src/pages/password-recovery/actions.js